/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var JewelDiamondIcon24Solid = forwardRef('JewelDiamondIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8.787 3H6.389c-.73 0-1.42.34-1.865.92L1.236 8.21c-.186.242-.318.51-.397.79H5.89l2.897-6Z" }),
        React.createElement("path", { d: "M1.029 10.75c.097.181.22.352.366.507l9.48 9.997a1.55 1.55 0 0 0 2.25 0l9.48-9.997a2.35 2.35 0 0 0 .366-.507H17.95l-5.182 9.422a.875.875 0 0 1-1.534 0L6.051 10.75H1.03Z" }),
        React.createElement("path", { d: "M23.161 9a2.343 2.343 0 0 0-.397-.79l-3.288-4.29A2.35 2.35 0 0 0 17.61 3h-2.398l2.897 6h5.051Z" }),
        React.createElement("path", { d: "m13.27 3 2.896 6H7.834l2.896-6h2.54Z" }),
        React.createElement("path", { d: "M12 17.934 8.049 10.75h7.902L12 17.934Z" })));
});
